export default __webpack_public_path__ + "static/media/bdit4da_tuto03-SQL-basics-v02.edf244a1.pdf";